import { NgModule } from "@angular/core";
import { RouterModule, type Routes } from "@angular/router";
// Import Containers

import { P404Component } from "./views/error/404.component";
import { P500Component } from "./views/error/500.component";

export const routes: Routes = [
    {
        path: "",
        redirectTo: "client",
        pathMatch: "full",
    },
    {
        path: "logout",
        redirectTo: "login",
        pathMatch: "full",
    },
    {
        path: "404/:error-type",
        component: P404Component,
        data: {
            breadcrumb: "Page 404",
        },
    },
    {
        path: "500",
        component: P500Component,
        data: {
            breadcrumb: "Page 500",
        },
    },
    {
        path: "",
        data: {
            breadcrumb: "Account",
        },
        loadChildren: () =>
            import("./account/account.module").then(
                (m) => m.Firm360AccountModule,
            ),
    },
    {
        path: "",
        data: {
            breadcrumb: "Calendar",
        },
        loadChildren: () =>
            import("./calendar/calendar.module").then((m) => m.CalendarModule),
    },
    {
        path: "",
        data: {
            breadcrumb: "",
        },
        loadChildren: () =>
            import("./entities/entity.module").then(
                (m) => m.Firm360EntityModule,
            ),
    },
    {
        path: "",
        data: {
            breadcrumb: "",
        },
        children: [
            {
                path: "dashboard",
                loadChildren: () =>
                    import("./views/dashboard/dashboard.module").then(
                        (m) => m.DashboardModule,
                    ),
            },
        ],
    },
    {
        path: "",
        data: {
            breadcrumb: "",
        },
        children: [
            {
                path: "reporting",
                loadChildren: () =>
                    import("./views/reporting/reporting.module").then(
                        (m) => m.ReportingModule,
                    ),
            },
        ],
    },
    {
        path: "",
        data: {
            breadcrumb: "",
        },
        children: [
            {
                path: "",
                loadChildren: () =>
                    import("./views/secure-links/secure-links.module").then(
                        (m) => m.SecureLinksModule,
                    ),
            },
        ],
    },
    {
        path: "",
        data: {
            breadcrumb: "",
        },
        children: [
            {
                path: "system",
                loadChildren: () =>
                    import("./views/system/system.module").then(
                        (m) => m.SystemModule,
                    ),
            },
        ],
    },
    { path: "**", component: P404Component },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { scrollPositionRestoration: "top" }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
